<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="show"
    :before-close="closeDialog"
    width="480px"
    :close-on-press-escape="false"
    @close="closeDialog"
  >
    <div slot="title">
      <div class="titleBox">
        <i class="el-icon-warning" />
        {{ title }}
      </div>
    </div>
    <div class="confirm-wrap">
      <div class="wrap-content">
        <h5>{{ contentHd }}</h5>
      </div>
      <p v-if="contentBd">{{ contentBd }}</p>
      <!-- 自定义 -->
      <slot />
    </div>
    <div slot="footer">
      <el-button v-if="showCancel" size="small" @click="clickCancel">{{ cancelBtn }}</el-button>
      <el-button size="small" type="primary" @click="clickSure">{{ sureBtn }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 防抖函数
function debounce(func, wait = 200) {
  let timeout
  return function(event) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.call(this, event)
    }, wait)
  }
}

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    contentHd: {
      type: String,
      default: ''
    },
    contentBd: {
      type: String,
      default: ''
    },
    sureBtn: {
      type: String,
      default: '确定'
    },
    cancelBtn: {
      type: String,
      default: '取消'
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    changeVisible() {
      this.show = !this.show
      this.noScroll()
    },
    clickCancel() {
      this.$emit('cancel')
      this.show = false
    },
    clickSure: debounce(function(e) {
      this.$emit('sure')
    }, 400),
    noScroll() {
      const hmain = document.getElementsByClassName('app-main')
      hmain[0].style.overflow = 'hidden'
    },
    canScroll() {
      const hmain = document.getElementsByClassName('app-main')
      hmain[0].style.overflow = 'auto'
    },
    closeDialog(done) {
      this.$emit('close')
      this.canScroll()
      done && done()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap-content {
  display: flex;
  align-items: center;
}
  /deep/ .el-dialog__body {
    padding: 27px 32px 27px 68px;
  }
  /deep/ .el-dialog {
    margin-top: 33vh !important;
    border-radius: 6px;
  }
  .titleBox {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    vertical-align: top;

    i {
      color: #f7993d;
      font-size: 20px;
      margin-right: 12px;
      line-height: 20px;
    }
    span {
      display: inline-block;
    }
  }
  .confirm-wrap {
    /*text-align: center;*/
    h5 {
      font-size: 14px;
      font-weight: 400;
      color: #F53F3F;
    }

    span {
      font-size: 14px;
      color: #333;
    }

    div {
      font-size: 15px;

      /*&:last-of-type {*/
      /*  margin-bottom: 40px;*/
      /*}*/

      h5 {
        display: inline-block;
        margin: 0;
      }
    }

  }
  .sys-deep-style {
    .titleBox {
      color: #fff;
    }
    .el-dialog__wrapper {
      /deep/ .el-dialog {
        border: 1px solid rgba(173, 178, 182, 0.3);
      }
    }
  }
</style>
